//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const { CanvasManager } = window.MattingEngineModule;
export default {
  name: "MattingCanvas",
  mounted() {
    new CanvasManager(this.$refs.source, this.$refs.result, {
      container: this.$refs.container,
    });
  },
};
